import '../../../../../../vendor/assets/javascripts/waypoints.min';

window.Reverb = window.Reverb || {};

Reverb.BlogNavigation = (function () {
  const body = 'body';
  const activeNavClass = 'active';
  const blogHeader = '.blog-header';

  function init() {
    handleNavigationTrigger();
  }

  function handleNavigationTrigger() {
    if (Reverb.MobileDetection.isMobileBrowser()) return false; // stopping function when on mobile

    $(blogHeader).waypoint(displayFixedNavigation, {
      offset() {
        return -$(this).height();
      },
    });
  }

  function displayFixedNavigation(direction) {
    if (direction === 'down') $(this).addClass(activeNavClass);
    else $(this).removeClass(activeNavClass);
  }

  return {
    init,
  };
}());

$(Reverb.BlogNavigation.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/blog/blog_navigation.js